// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__xTnIT","modal":"Modal_modal__DJDMv","closeBtn":"Modal_closeBtn__mlOa4","iconClose":"Modal_iconClose__AUpu-"};